/**
 * GPU-accelerated loading dots indicator.
 * Uses will-change and contain to minimize repaint scope.
 */
export const LoadingDots = () => (
  <span
    class="inline-flex items-center gap-1"
    style={{ contain: "layout style", "will-change": "transform" }}
    aria-label="Loading"
  >
    <span
      class="size-1 animate-bounce rounded-full bg-brand"
      style={{ "animation-delay": "0ms", "will-change": "transform" }}
    />
    <span
      class="size-1 animate-bounce rounded-full bg-brand"
      style={{ "animation-delay": "150ms", "will-change": "transform" }}
    />
    <span
      class="size-1 animate-bounce rounded-full bg-brand"
      style={{ "animation-delay": "300ms", "will-change": "transform" }}
    />
  </span>
);
